import { Outlet } from 'react-router-dom'
import { ErrorBoundary } from './ErrorBoundary'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'
import { TopBar } from './TopBar'
import { Measurement } from './Measurement'

export function Layout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      {import.meta.env.DEV && import.meta.env.VITE_FIREBASE_USE_EMULATORS === 'true' && (
        <div className="bg-amber-100 px-4 py-2 text-center text-sm text-amber-950">
          Ambiente de desenvolvimento — consultas de homologação e pagamentos de teste.
        </div>
      )}
      <TopBar />
      <SiteHeader />
      {/* O erro fica contido no miolo: cabeçalho e rodapé sobrevivem. */}
      <main className="flex-1">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <SiteFooter />
      <Measurement />
    </div>
  )
}
